import { COLUMN_PART } from "../hub-table.constants";
import type { HubTableColumnProps } from "../types-hub-table";

/** Descreve uma coluna: o Root a converte em `Column` do Prime (visibilidade e ordenação incluídas); não renderiza. */
export function HubTableColumn<T, C extends string = string>(props: HubTableColumnProps<T, C>) {
  void props;
  return null;
}
HubTableColumn.displayName = COLUMN_PART;
